export default __webpack_public_path__ + "assets/check.cc9ebc0a.svg";